import {
  getMessageFromElements,
  getQuestionFromElements,
  useFormFactory,
} from '@meilleurtaux/form-factory'
import { Message, StepContent, useDeviceDetection } from '@meilleurtaux/form-factory-ds'
import { Fragment } from 'react'
import QuestionManager from './QuestionManager'
import type { Slide, Group as SlideGroup } from '@meilleurtaux/form-factory'
import type { Control, FieldValues, FieldErrors, UseFormGetFieldState } from 'react-hook-form'
import type { ObjectSchema, AnyObject } from 'yup'
import { getLastQuestionDisplayInSlide } from 'utils/questionManager'

interface SlideContentProps {
  slide: Slide
  control: Control<FieldValues>
  errors: FieldErrors<FieldValues>
  validationSchema: ObjectSchema<
    {
      [x: string]: unknown
    },
    AnyObject,
    {
      [x: string]: undefined
    },
    ''
  >
  getFieldState: UseFormGetFieldState<{
    [key: string]: string
  }>
  goNextOnSelect: boolean
}

const SlideContent = ({
  slide,
  control,
  errors,
  validationSchema,
  getFieldState,
  goNextOnSelect,
}: SlideContentProps) => {
  const { saveResponse } = useFormFactory(import.meta.env.VITE_API_URL)
  const device = useDeviceDetection()
  const lastQuestionExtraInfo = getLastQuestionDisplayInSlide(slide)?.extraInfo

  return (
    <>
      {slide.groups
        .filter(
          (group) =>
            getQuestionFromElements(group.elements).find((question) => question.display) ??
            getMessageFromElements(group.elements).find((message) => message.display),
        )
        .map((group: SlideGroup) =>
          group.elements.length === 1 && group.elements[0].type === 'message' ? (
            <div key={group.id} style={{ marginBottom: device === 'Mobile' ? '-20px' : '-32px' }}>
              <Message
                message={group.elements[0].message}
                template={group.elements[0].messageTemplate}
              />
            </div>
          ) : (
            <Fragment key={group.id}>
              <StepContent
                isInSubGroup={group.elements.length > 1}
                isAfterMessage={group.isAfterMessage}
                template={'template' in group ? group.template : undefined}
              >
                <QuestionManager
                  currentStep={group}
                  control={control}
                  errors={errors}
                  validationSchema={validationSchema}
                  lastQuestionExtraInfo={lastQuestionExtraInfo}
                  getFieldState={getFieldState}
                  saveResponse={saveResponse}
                  goNextOnSelect={goNextOnSelect}
                />
              </StepContent>
            </Fragment>
          ),
        )}
    </>
  )
}

export default SlideContent
